<template lang='pug'>
.content
  grid(
  :model="getModel"
  name='',
  label='Business Unit'
  desc=''
  :views='false'
  layout='frame'
  search=true
  resizing=false
  :endpoint='api.$.BUAndCC.getBusinessUnits'
  :actions='actions'
  @removeRow='removeBU'
  @removeRows='removeBUs'
  @changeRow='editBU'
  remove-many
  fit-columns
  ref='BusinessUnitsGrid'
)
    span(slot='additionalButtons')
      ed-button.btn.btn-actionbar(
        @click="addBU") Add BU
</template>

<script>

import Grid from '@/components/Grid'
import {remove} from '@/components/Grid/cells/actions'
import BUModel from './BUModel.js'
import { EventBus } from '@/event-bus'
import events from '@/core/events/events'

export default {
  components: {
    Grid
  },

  data() {
    return {
      BUModel,
      actions: [remove]
    }
  },

  computed: {
    getModel() {
      return BUModel.get()
    }
  },

  created() {
    EventBus.$on(events.BU_CC.REFRESH, r => {
      this.refresh()
    })
  },

  methods: {
    editBU (payload, success, fail) {
      //
      if (!this.validBU(payload.data)) {
        fail('Invalid Business Unit')
      } else {
        this.api.post(this.api.$.BUAndCC.saveBusinessUnit, payload.data)
          .then(r => success(r))
          .catch(e => fail())
      }
    },
    removeBU(payload, success, fail) {
      //
      var id = +payload.data.BusinessUnitId
      this.api.delete(this.api.$.BUAndCC.deleteBusinessUnit + '/' + id, id)
        .then(r => success())
        .catch(e => fail('Something went wrong. Cannot delete the Business Unit'))
    },
    removeBUs (payload) {
      //
      var businessUnitIds = []
      payload.rows.forEach(element => {
        businessUnitIds.push(element.data.BusinessUnitId)
      })
      var p = {
        IDs: businessUnitIds
      }
      this.api.post(this.api.$.BUAndCC.deleteBusinessUnits, p).then(this.validateDeleteBUs)
    },

    validBU(data) {
      //
      var isValid = true
      if (data.BusinessUnitName.trim() === '') {
        isValid = false
      }
      return isValid
    },

    addBU() {
      this.$refs.BusinessUnitsGrid.addRow({})
    },

    refresh() {
      this.$refs.BusinessUnitsGrid.quickSearch()
      this.$refs.BusinessUnitsGrid.onSelectAll(false)
    },

    validateDeleteBUs(r) {
      if (r.data.Errors.length !== 0) {
        alert('Something went wrong. Cannot delete the Business Units.')
      }
      EventBus.$emit(events.BU_CC.REFRESH)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/BusinessUnitsAndCostCenters/BU-list/index.vue